import { render } from "./WaitView.vue?vue&type=template&id=76173a73"
import script from "./WaitView.vue?vue&type=script&lang=js"
export * from "./WaitView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__